import styled from 'styled-components';
import { background } from '../img';
import { sizes } from '../config/general';

export const Content = styled.div`
	height: calc(100vh - ${sizes.nav.height.desktop});
	padding-top: ${sizes.nav.height.desktop};
	padding-left: 20px;
	color: white;
	font-weight: 100;
	overflow-y: scroll;
	-webkit-overflow-scrolling: touch;
`;

export const Tagline = styled.div`
	display: flex;
	align-items: center;
	transform: TranslateY(-20%);
	height: 100%;
`;

export const Header = styled.h4`
	font-size: 40px;
	font-weight: 400;
`;

export const TagWrapper = styled.div`
	text-align: center;
	margin: 0 auto;

	& p {
		font-size: 30px;
	}

	& small {
		font-size: 14px;
	}
`;

export const Footer = styled.div`
	position: fixed;
	bottom: 0;
	left: 0;
	width: 100%;
	height: 30px;
	display: flex;
	align-items: center;
	background-color: black;
	box-shadow: 0px -2px 10px 5px black;

	& a {
		color: grey;
		text-decoration: none;
	}

	& span.left {
		padding-left: 10px;		
		padding-bottom: 5px;
		color: grey;
		font-size: 12px;
		float: left;
	}

	& span.right {
		padding-bottom: 5px;
		color: grey;
		font-size: 12px;
		float: right;
		padding-right: 10px;		
	}

	& span.center {
		margin: 0 auto;
	}
`;

export const MainImg = styled.img`
	width: 50%;
	max-width: 300px;
	display: block;
	margin: 0 auto;
`;

export const FadeIn = styled.div`
	@keyframes v38FadeIn {
		0% { opacity: 0; }
		100% { opacity: 1; }
	}

	animation: v38FadeIn 2s;
`;

export const Wrapper = styled(FadeIn)`
width: 100vw;
height: 100vh;
background: 
	linear-gradient(
		180deg,
		rgba(0, 0, 0, 1) 0%,
		rgba(0, 0, 0, 1) 45%,
		rgba(0, 0, 0, 0.9) 65%,
		rgba(0, 0, 0, 0.85) 70%,
		rgba(0, 0, 0, 0.8) 75%,
		rgba(0, 0, 0, 0.75) 80%,
		rgba(0, 0, 0, 0.7) 85%,
		rgba(0, 0, 0, 0.65) 90%,
		rgba(0, 0, 0, 0.6) 95%,
		rgba(0, 0, 0, 0.5) 100%
	),
	url(${background});

background-size: cover;
background-position: bottom;
`;


// WEBPACK FOOTER //
// ./src/components/general.js